//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Hestia",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
        item8: '0',
        item9: '0',
        item10: '0',
        item11: '0',

      },
      descTxt: ''
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6 + form.item7 + form.item8 + form.item9 + form.item10 + form.item11
        if (result > 0) {
          self.descTxt = '建议入院治疗'
        } else {
          self.descTxt = '可在院外治疗'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Hestia.vue